import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: true,
};

export const postResetPassword = createAsyncThunk(
  "account/postResetPassword",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.resetPassword(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const resetPasswordSlice = createSlice({
  name: "resetPass",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(postResetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(postResetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(postResetPassword.rejected, (state, error) => {
        state.loading = false;
        state.value = error.payload;
      });
  },
});

export const resetPasswordList = (state) => state.resetPassword.value;
export const loading = (state) => state.resetPassword.loading;
export default resetPasswordSlice.reducer;
